<template>
  <AnalyticsTemplate 
    page-title="桥梁预警统计"
    chart-type="alert"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'AlertAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
